import styled from 'styled-components';
import PostWritingContainer from '../PostWritingContainer';

const PostWritingContainerWithMg = styled(PostWritingContainer)`
  margin-top: 24px;
  margin-bottom: 32px;
`;

export default PostWritingContainerWithMg;
